import { useTranslation } from 'react-i18next';
import { Trophy, TShirt, Package } from '@phosphor-icons/react';

const PrizeBanner = ({ variant = 'default' }) => {
  const { t } = useTranslation();

  if (variant === 'compact') {
    return (
      <div className="relative bg-gradient-to-r from-[#FFD700]/10 via-[#FFD700]/5 to-transparent border border-[#FFD700]/30 rounded-sm p-4 overflow-hidden" data-testid="prize-banner-compact">
        <div className="absolute top-0 right-0 w-24 h-24 bg-[#FFD700]/5 rounded-full -translate-y-8 translate-x-8" />
        <div className="relative flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-[#FFD700]/15 rounded-sm flex-shrink-0">
            <Trophy size={22} weight="fill" className="text-[#FFD700]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[#FFD700] font-bold text-sm uppercase tracking-wide">{t('prize.tagline')}</p>
            <p className="text-text-secondary text-xs mt-0.5">{t('prize.jerseyChoice')}</p>
          </div>
          <div className="hidden sm:flex items-center gap-1 text-text-muted text-xs">
            <Package size={14} />
            <span>{t('prize.freeShipping')}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative bg-background-paper border-2 border-[#FFD700]/40 rounded-sm overflow-hidden" data-testid="prize-banner">
      <div className="absolute inset-0 bg-gradient-to-br from-[#FFD700]/8 via-transparent to-[#FFD700]/4" />
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#FFD700]/5 rounded-full -translate-y-32 translate-x-32" />
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#FFD700]/5 rounded-full translate-y-16 -translate-x-16" />

      <div className="relative p-6">
        <div className="flex items-start gap-4">
          <div className="flex items-center justify-center w-14 h-14 bg-[#FFD700]/15 rounded-sm flex-shrink-0">
            <Trophy size={32} weight="fill" className="text-[#FFD700]" />
          </div>
          <div className="flex-1">
            <p className="text-[#FFD700] font-black text-xs uppercase tracking-[0.2em] mb-1">{t('prize.winnerTakes')}</p>
            <h3 className="font-heading text-xl sm:text-2xl font-black tracking-tight text-white mb-2">
              {t('prize.headline')}
            </h3>
            <p className="text-text-secondary text-sm leading-relaxed mb-4">
              {t('prize.description')}
            </p>

            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 bg-background/60 px-3 py-1.5 rounded-sm border border-border">
                <TShirt size={16} className="text-[#FFD700]" />
                <span className="text-white text-xs font-medium">{t('prize.countryJersey')}</span>
              </div>
              <div className="flex items-center gap-2 bg-background/60 px-3 py-1.5 rounded-sm border border-border">
                <TShirt size={16} className="text-[#1E3A8A]" />
                <span className="text-white text-xs font-medium">Birmingham City</span>
              </div>
              <div className="flex items-center gap-2 bg-background/60 px-3 py-1.5 rounded-sm border border-border">
                <TShirt size={16} className="text-white" />
                <span className="text-white text-xs font-medium">Santos FC</span>
              </div>
              <div className="flex items-center gap-2 bg-background/60 px-3 py-1.5 rounded-sm border border-border">
                <Package size={16} className="text-[#FFD700]" />
                <span className="text-white text-xs font-medium">{t('prize.freeWorldwide')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrizeBanner;
